import React from 'react';
import { FileText, ExternalLink, Download, Smartphone } from 'lucide-react';

export default function PdfGuideCard({ translations: t, language }) {
  // Support custom PDF URL via .env, or default to the language-specific file in /public
  const defaultPdf = language === 'de' ? "/MFA-Guide-DE.pdf" : "/MFA-Guide.pdf";
  const pdfUrl = import.meta.env.VITE_PDF_GUIDE_URL || defaultPdf;

  return (
    <div className="bg-white rounded-3xl border border-slate-200/90 p-5 sm:p-6 shadow-sm flex flex-col gap-4">
      
      {/* Top section: PDF Info & Button */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4 text-center sm:text-left">
          <div className="w-12 h-12 rounded-2xl bg-[#fee2e2] border border-[#fecaca] flex items-center justify-center text-[#e30613] shrink-0 shadow-2xs">
            <FileText className="w-6 h-6" />
          </div>
          <div>
            <h3 className="text-sm sm:text-base font-bold text-slate-900">
              {t.pdfGuideTitle}
            </h3>
            <p className="text-xs text-slate-500 mt-0.5">
              {t.pdfGuideDesc}
            </p>
          </div>
        </div>

        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-xs sm:text-sm font-semibold text-slate-800 bg-slate-100 hover:bg-slate-200 border border-slate-200/80 transition-colors shrink-0 w-full sm:w-auto justify-center shadow-2xs"
        >
          <Download className="w-4 h-4 text-slate-600" />
          <span>{t.pdfGuideButton}</span>
          <ExternalLink className="w-3.5 h-3.5 text-slate-400" />
        </a>
      </div>

      {/* Bottom section: Company Device Pre-installed Notice */}
      <div className="pt-3 border-t border-slate-100 flex items-center justify-center sm:justify-start gap-2 text-xs font-medium text-[#005930] bg-[#f0f9f4] py-2.5 px-3.5 rounded-xl border border-[#bae3cb]/80">
        <Smartphone className="w-4 h-4 text-[#008446] shrink-0" />
        <span>{t.appPreinstalledNotice}</span>
      </div>

    </div>
  );
}
